import { render, staticRenderFns } from "./compWrap.vue?vue&type=template&id=e649dd32&scoped=true&"
import script from "./compWrap.vue?vue&type=script&lang=js&"
export * from "./compWrap.vue?vue&type=script&lang=js&"
import style0 from "./compWrap.vue?vue&type=style&index=0&id=e649dd32&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e649dd32",
  null
  
)

export default component.exports